
import { Component, Vue, Prop, Watch, Emit, Mixins, Ref } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import CalendarCard from '../CalendarCard/index.vue'
import LiveClasshourCard from '../LiveClasshourCard/index.vue'
import LazyImg from '@/components/lazyImg/index.vue'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import moment from 'moment'
import lodash from 'lodash'
import { ICalendarData } from '@xt/client/types/my-go-course'
import { $service } from '@xt/client/experimental/request/service'

type CalendarDataType = {
  y: number
  m: number
  d: number
  w: number
  timestamp: number
}

@Component({
  components: {
    Title,
    LazyImg,
    NewSwiper,
    CalendarCard,
    LiveClasshourCard
  }
})
export default class MyCalendar extends Vue {
  timeData: Array<CalendarDataType> = []

  currentDate: {
    currentYear: number
    currentMonth: number
    currentDay: number
  } | null = null
  activeDate: {
    activeYear: number
    activeMonth: number
    activeDay: number
  } | null = null

  calendarData: Array<
    ICalendarData & {
      y: number
      m: number
      d: number
    }
  > = []
  classhourInfo: Array<ICalendarData> = []
  calendarImg: string = ''

  @Ref()
  swiper: {
    dotScrollTo: (idx: number) => void
  }

  get dataList() {
    return lodash.chunk(this.timeData, 7)
  }

  /** 是否存在课时 */
  isExistClasshour(item: CalendarDataType) {
    return (
      this.calendarData.findIndex(v => {
        // 如果是头部临时课 ｜ 尾部临时课
        if (v.classhourType !== 1) {
          return v.d === item.d && v.m === item.m && v.y === item.y && v.publishStatus === 1
        }
        return v.d === item.d && v.m === item.m && v.y === item.y
      }) > -1
    )
  }

  handleChangeActive(date: Omit<CalendarDataType, 'w' | 'timestamp'>) {
    this.updateActiveDate(date)
    this.updateClasshourInfo(date)
  }

  updateClasshourInfo(date: Omit<CalendarDataType, 'w' | 'timestamp'>) {
    if (!this.calendarData) return []

    // 年 月 日相等 && 如果是头部临时课或者尾部临时课，就需要判断发布状态
    this.classhourInfo = this.calendarData.filter(
      item => item.d === date.d && item.m === date.m && item.y === date.y && (item.classhourType !== 1 ? item.publishStatus === 1 : true)
    )
  }

  // 点击更新日期
  updateActiveDate({ y, m, d }: { y: number; m: number; d: number }) {
    this.activeDate = {
      activeYear: y,
      activeMonth: m,
      activeDay: d
    }
  }

  // 获取当前时间
  updateCurrentTime() {
    let currentTime = this.$ajax.serviceDate().valueOf()
    const { y, m, d } = this.formatYearMonthDay(currentTime)

    this.currentDate = {
      currentYear: y,
      currentMonth: m,
      currentDay: d
    }
  }

  get21DayCalendarData() {
    let currentTime = this.$ajax.serviceDate().utcOffset(+8).valueOf() || undefined
    let week = moment(currentTime).startOf('isoWeek')
    let dayTime = 24 * 1000 * 60 * 60
    let time = week.subtract(7, 'days').valueOf()
    let currWeek: any[] = []
    for (let i = 0; i < 21; i++) {
      let item = moment(time)
      const [y, m, d] = item
        .format('YYYY-MM-DD')
        .split('-')
        .map(v => parseInt(v))
      currWeek.push({ w: item.day(), y, m, d, timestamp: item.valueOf() })
      time += dayTime
    }
    return currWeek
  }

  getDayOfWeekUrl(index: number) {
    return `${this.$store.$global.static}/images/my-new/pc/my-classroom-calender-ico${index}.svg`
  }

  formatYearMonthDay(currentTime: number) {
    const [y, m, d] = moment(currentTime)
      .format('YYYY-MM-DD')
      .split('-')
      .map(v => parseInt(v))

    return {
      y,
      m,
      d
    }
  }

  singlePadding(num) {
    return num <= 9 ? '0' + num : num
  }

  // 加载日历背景图
  async loadCalendarBgImg(month: number) {
    const [err, data] = await $service<{
      cover: string[]
    }>({
      method: 'GET',
      url: '/mocks/calendar-uc.json',
      baseURL: this.$store.$global.static
    })

    if (err) throw err

    this.calendarImg = data?.cover.length === 12 ? data.cover[month] : ''
  }

  // 加载课时列表数据
  async loadClasshourList() {
    const { y, m, d } = this.timeData[0]
    const res: Array<ICalendarData> = await this.$store.$storeCourse.Details.ClasshourLive.onCalendarInfo(
      moment(`${this.singlePadding(y)}-${this.singlePadding(m)}-${this.singlePadding(d)}`).valueOf(),
      21
    )
    // 数据处理
    this.calendarData = res.map(i => {
      const { y, m, d } = this.formatYearMonthDay(i.startTime)
      return {
        ...i,
        y,
        m,
        d
      }
    })
  }

  async created(): Promise<void> {
    // 获取21天日历数据
    this.timeData = this.get21DayCalendarData()

    // 初始化当前时间
    this.updateCurrentTime()
    const { currentYear, currentMonth, currentDay } = this.currentDate!

    // 初始化选中时间，默认选中今天
    this.updateActiveDate({
      y: currentYear,
      m: currentMonth,
      d: currentDay
    })

    // 初始化日历图片
    await this.loadCalendarBgImg(currentMonth - 1)

    // 初始化课时数据
    await this.loadClasshourList()

    // 初始化当前选中日期的课时信息
    this.updateClasshourInfo({
      y: currentYear,
      m: currentMonth,
      d: currentDay
    })
  }

  mounted(): void {
    this.$nextTick(() => {
      this.swiper.dotScrollTo(1)
    })
  }

  updated(): void {}

  destroyed(): void {}
}
